import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';
import '../styles/styles.css';

const COLORS = ['#00c8ff', '#009ecc', '#007a99', '#005f66', '#004d4d', '#003333'];


const dataFrontend = [
  { name: 'CSS/Figma', value: 50 },
  { name: 'HTML', value: 30 },
  { name: 'JavaScript', value: 20 },
];


const dataBackend = [
  { name: 'PHP', value: 70 },
  { name: 'MySQL', value: 30 },
];


const dataFrameworks = [
  { name: 'Bootstrap', value: 60 },
  { name: 'React', value: 40 },
];


const dataMobile = [
  { name: 'Android', value: 70 },
  { name: 'iOS', value: 30 },
];

const dataLanguages = [
  { name: 'JavaScript', value: 95 },
  { name: 'PHP', value: 85 },
  { name: 'HTML', value: 80 },
  { name: 'Kotlin', value: 70 },
  { name: 'Python', value: 50 },
  { name: 'Java', value: 30 },
];



const Skills = () => {
  return (
<section id="skills-section" className="skills-section">
  <h2 className="skills-title">Mis habilidades técnicas</h2>

  <div className="skills-layout">
    {/* 📊 Gráficas a la izquierda */}
    <div className="skills-graphs">
      {/* Donuts */}
      <div className="skills-grid">
        {/* Frontend */}
        <div className="skills-chart">
          <h3 className="skills-subtitle">Frontend</h3>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie data={dataFrontend} dataKey="value" cx="50%" cy="50%" outerRadius={60} label>
                {dataFrontend.map((entry, index) => (
                  <Cell key={`cell-front-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Backend */}
        <div className="skills-chart">
          <h3 className="skills-subtitle">Backend</h3>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie data={dataBackend} dataKey="value" cx="50%" cy="50%" outerRadius={60} label>
                {dataBackend.map((entry, index) => (
                  <Cell key={`cell-back-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Frameworks */}
        <div className="skills-chart">
          <h3 className="skills-subtitle">Frameworks</h3>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie data={dataFrameworks} dataKey="value" cx="50%" cy="50%" outerRadius={60} label>
                {dataFrameworks.map((entry, index) => (
                  <Cell key={`cell-fw-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Mobile */}
        <div className="skills-chart">
          <h3 className="skills-subtitle">Mobile</h3>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie data={dataMobile} dataKey="value" cx="50%" cy="50%" outerRadius={60} label>
                {dataMobile.map((entry, index) => (
                  <Cell key={`cell-mobile-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Barras */}
      <h3 className="skills-title" style={{ marginTop: '60px' }}>Lenguajes de Programación</h3>
      <div className="skills-bar-chart">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={dataLanguages} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#444" />
            <XAxis dataKey="name" stroke="#fff" />
            <YAxis stroke="#fff" />
            <Tooltip />
            <Bar dataKey="value" barSize={40}>
  {dataLanguages.map((entry, index) => (
    <Cell key={`bar-cell-${index}`} fill={COLORS[index % COLORS.length]} />
  ))}
</Bar>

          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>

    {/* 🎓 Estudios a la derecha */}
    <div className="skills-education">
      <h3 className="skills-title">Formación Académica</h3>
      <ul>
        <li>
          <strong>Ingeniería Informática</strong><br />
          Universidad Católica del Norte<br />
          <em>2025</em><br />
          Enfoque en desarrollo UI/UX
        </li>
        <li style={{ marginTop: '1rem' }}>
          <strong>Tecnología en Desarrollo de Software</strong><br />
          Universidad Católica del Norte<br />
          <em> 2024</em><br />
          Enfoque en automatización, proyectos con Arduino y ciberseguridad
        </li>
      </ul>

      <h3 className="skills-title" style={{ marginTop: '2rem' }}>Formación Complementaria</h3>
      <ul>
        <li>Diplomado en Ciberseguridad</li>
        <li>Curso de Inteligencia Artificial para Optimización del Trabajo</li>
        <li>Diplomado en Gestión Comercial Integral</li>
      </ul>
    </div>
  </div>
</section>

  );
};

export default Skills;
